module.exports = __webpack_public_path__ + "img/floor_bg.d6d7586e.jpg";